<script lang="ts">
    import MainLayout from "../../#common/layout/Layout.svelte"
    import {Link} from 'svelte-routing'
    import {doShow as showAlert} from "src/components/cabinet/#common/alert/store"
    import {api, DataType} from 'src/services/api/reallis'
    import {getNews, updateNews} from 'src/components/cabinet/#services/blogNews'
    export let id

    getNews.reset()
    getNews.send({ data: { id: +id } })

    let saved = false
    let appId
    let image

    let newsInfo
    $: if (!newsInfo && $getNews.hasValue) {
        newsInfo = $getNews.value && JSON.parse(JSON.stringify($getNews.value))
        appId = newsInfo.appId
    }

    const images_upload_handler = (blobInfo, _) => new Promise(async (resolve, reject) => {
        try {
            let response = await api.http.request({
                method: 'post',
                url: process.env.IMAGE_UPLOAD_URL + 'blog',
                dataType: DataType.MultipartFormData,
                data: { image: blobInfo.blob() }
            });
            resolve(`${process.env.IMAGES_PATH}${response.data?.location}`);
        } catch (err) {
            reject('An Error Occurred, Please Try Again Later');
        }
    });

    async function onFileSelected(imageFile) {
        try {
            let response = await api.http.request({
                method: 'post',
                url: process.env.IMAGE_UPLOAD_URL+'blog',
                dataType: DataType.MultipartFormData,
                data: { image: imageFile }
            })
            newsInfo.image = response.data?.location
        } catch (err) {
            showAlert.set({
                status: 'error',
                text: 'An Error Occurred, Please Try Again Later'
            })
        }
    }

    async function save() {
        delete newsInfo.createdAt
        delete newsInfo.updatedAt
        delete newsInfo.views

        saved = true

        if (newsInfo.question !== '') {
            try {
                updateNews.send({ data: newsInfo })

                showAlert.set({
                    status: 'success',
                    text: 'News successfully updated!'
                })
            } catch (e) {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }
</script>

<svelte:head>
    <title>Edit news</title>
</svelte:head>

<MainLayout title="Edit news">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <Link to="news" class="btn btn-primary mb-3">Back</Link>
                <div class="row mb-3">
                    <div class="col-lg-8">
                        {#if $getNews.loading}
                            Loading...
                        {:else if $getNews.error || !$getNews.hasValue}
                            An error has occurred
                        {:else if $getNews.value && newsInfo}
                            <div class="form-group mb-3">
                                <label>Game</label>
                                <select class="form-select" bind:value={newsInfo.appId}>
                                    <option value={3}>Crypto Cats</option>
                                    <option value={5}>Crypto Dragons (Android)</option>
                                    <option value={6}>Crypto Dragons (IOS)</option>
                                    <option value={7}>Crypto Fox</option>
                                    <option value={9}>Elemental Wars</option>
                                    <option value={11}>Crypto DOGE</option>
                                    <option value={13}>Elon Game</option>
                                    <option value={15}>Crypto Pepe</option>
                                </select>
                            </div>
                            <div class="form-group mb-3">
                                <label>Title</label>
                                <input type="text" class="form-control" bind:value={newsInfo.title}
                                    class:is-invalid={saved && newsInfo.title === ''}>
                            </div>
                            <div class="form-group mb-3">
                                <label>Main image</label>
                                <input type="file" class="form-control" accept=".jpg, .jpeg, .png, .gif" on:change={(e) => onFileSelected(e.target.files[0])}>
                                {#if newsInfo.image}
                                    <img class="main-image-thumb" src="{process.env.IMAGES_PATH}{newsInfo.image}" alt=""/>
                                {/if}
                            </div>
                            <div class="form-group mb-3">
                                <label>Content</label>
                                <textarea class="form-control" bind:value={newsInfo.content}></textarea>
                                <span class="help-block text-danger" class:d-block={saved && newsInfo.content === ''}
                                    style="display: none;">Enter content</span>
                            </div>
                        {/if}
                    </div>
                </div>
                <button class="btn btn-success" on:click={save}>Update</button>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .main-image-thumb {
        border: 1px solid #ced4da;
        height: 100px;
        margin: 15px 0 0;
        padding: 5px;
        border-radius: 0.25rem;
        cursor: pointer;
    }
</style>
